module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default agency--panel"
  }, [_c('div', {
    staticClass: "panel-body menu__panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        _vm.emitUserSearch(), _vm.emitTriggerReload()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1000) + "\n      ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_Create')) ? _c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-create-button"
    },
    on: {
      "click": function($event) {
        return _vm.emitEditAgency(true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1002) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_Read')) ? _c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-edit-button",
      "disabled": !_vm.agencySelected
    },
    on: {
      "click": function($event) {
        return _vm.emitEditAgency(false)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1003) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_Delete')) ? _c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-delete-button",
      "disabled": !_vm.agencySelected
    },
    on: {
      "click": function($event) {
        return _vm.emitDeleteAgency()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1008) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body paging__panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar__form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearch",
      "placeholder": _vm.lang.AM1001
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emitUserSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('ul', {
    staticClass: "pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1004))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === _vm.tableElementCount,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, -1)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1005))])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageNumbers.length || _vm.currentPage === 1,
    }
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    },
    on: {
      "click": function($event) {
        return _vm.selectPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1006))])], 1), _vm._v(" "), (_vm.pageNumbers.length > 5 && _vm.currentPage > 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.showPages), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.currentPage === pageNumber
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectPage(pageNumber)
        }
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (
    _vm.pageNumbers.length > 5 && _vm.currentPage < _vm.pageNumbers.length - 2
  ) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.pageNumbers.length || _vm.currentPage === _vm.pageNumbers.length,
    }
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    },
    on: {
      "click": function($event) {
        return _vm.selectPage(_vm.pageNumbers.length)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "agenciesTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.tableElementCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "agenciesTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1009))])], 1)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a81d124","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgencyManagement/AgencyManagementToolbar.vue
// module id = 1713
// module chunks = 1